import React, { useState, useEffect } from "react";
import { tableHeader } from "../DetailedBalanceSheet/BalanceSheetTable";
import { broadCloseIcon, broadOpenIcon } from "../../../assets/images";
import { getData } from "./common";
import "./costOfGoods.scss";
import { Link } from "react-router-dom";
import { currencySignAndNegativeValueAdjust, reverseDate } from "../../../utils/commonFunctions";
type AppProps = {
  singleData: any;
  type?: string;
  count: number;
  index?: number;
  recuIndex?: number;
  currencySign: string | undefined;
  inDirectData: any;
  isAllOpen: boolean;
  finalRedirectLink: { pathname: string };
  startDate: string;
  endDate: string;
  isLedgerStatementPresent?:boolean;
};

const CostOfGoodsStatementTableData = ({
  singleData,
  type,
  count,
  currencySign,
  recuIndex,
  index,
  inDirectData,
  isAllOpen,
  finalRedirectLink,
  startDate,
  endDate,
  isLedgerStatementPresent
}: AppProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (singleData?.isOpens) {
      setIsOpen(true)
    }
    else {
      setIsOpen(false)

    }
  }, [singleData])

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem('ledger_id', ledgerId.toString());
    localStorage.setItem('start_date', reverseDate(startDate));
    localStorage.setItem('end_date', reverseDate(endDate));
  };

  if (singleData?.data?.length > 0) {
    return (
      <>
        <tr>
          {tableHeader?.map((thead: any) => {
            if (thead?.value === "ledger_name") {
              return (
                <td
                  style={{
                    paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "",
                  }}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <p style={{ marginLeft: "-32px", fontWeight: "700" }}>
                    <span
                      style={{ display: "inline-block", marginRight: "2px" }}
                    >
                      {isOpen ? (
                        <img
                          width="30px"
                          style={{ cursor: "pointer" }}
                          src={broadOpenIcon}
                          className="accordion-arrow"
                          alt="open"
                        />
                      ) : (
                        <img
                          width="30px"
                          style={{ cursor: "pointer" }}
                          src={broadCloseIcon}
                          className="accordion-arrow"
                          alt="close"
                        />
                      )}
                    </span>
                    {singleData?.ledger_name}
                  </p>
                </td>
              );
            }
            if (thead?.value === "closing_amount") {
              return (
                <td style={{ verticalAlign: "middle" }}>
                  {!isOpen ? (
                    <p className="bold-count" style={{ fontWeight: "700" }}>
                      {" "}
                      {singleData?.total_amount
                        ? currencySignAndNegativeValueAdjust(currencySign,singleData?.total_amount?singleData?.total_amount?.toFixed(2)?.toString():"")
                        : 0}
                    </p>
                  ) : (
                    ""
                  )}
                </td>
              );
            }
          })}
        </tr>

        {isOpen && (
          <>
            {getData(singleData?.data)?.map((item: any, recuIndex: number) => (
              <CostOfGoodsStatementTableData
                singleData={item}
                type="recurring"
                count={count + 1}
                currencySign={currencySign}
                recuIndex={recuIndex}
                inDirectData={inDirectData}
                isAllOpen={isAllOpen}
                finalRedirectLink={finalRedirectLink}
                startDate={startDate}
                endDate={endDate}
                isLedgerStatementPresent={isLedgerStatementPresent}
              />
            ))}
          </>
        )}
      </>
    );
  } else {
    return (
      <tr>
        {tableHeader?.map((thead: any) => {
          if (thead?.value === "ledger_name") {
            return (
              <td
                style={{
                  paddingLeft: type == "recurring" ? `${3.9 * count}rem` : "",
                }}
              >
                {singleData?.ledger_type_id === "Opening Stock" || singleData?.ledger_type_id === "TOTAL COST OF ALL DIRECT EXPENSE LEDGER" || singleData?.ledger_type_id === "All Direct Expense Ledger" || singleData?.ledger_type_id === "Closing Stock" || singleData?.ledger_type_id === "All Indirect Expense Ledger" ? (
                  singleData?.ledger_name
                ) : singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers" ? <p
                  style={{
                    fontWeight: singleData?.ledger_type_id === "TOTAL COST OF ALL DIRECT EXPENSE LEDGER" ? 700 : "",

                    color:
                      singleData?.ledger_id === "Indirect Ledgers" ? "#744bd1" : singleData?.ledger_id === "Direct Ledgers"
                        ? "#2080f6"
                        : "#dd4433",
                    padding:
                      singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers"
                        ? "4px 12px"
                        : "",
                  }}
                  className={
                    singleData?.ledger_id === "Indirect Ledgers" ? "in-directLedgers" : singleData?.ledger_id === "Direct Ledgers" ? "directLedgers"
                      : ""
                  }
                >
                  {singleData?.ledger_name}
                </p> :  isLedgerStatementPresent ? (
                  <Link
                    target='_blank'
                    to={finalRedirectLink}
                    onClick={() => handleSetLocalStorageData(singleData?.ledger_id)}
                    style={{ textDecoration: 'underLine', cursor: 'pointer', color: "#dd4433" }}
                  >
                    <p
                      style={{
                        textDecoration:
                          singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers"
                            ? ""
                            : "underLine",
                        cursor: "pointer",
                        color:
                          singleData?.ledger_id === "Indirect Ledgers" ? "#744bd1" : singleData?.ledger_id === "Direct Ledgers"
                            ? "#2080f6"
                            : "#dd4433",
                        padding:
                          singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers"
                            ? "4px 12px"
                            : "",
                      }}
                      className={
                        singleData?.ledger_id === "Indirect Ledgers" ? "in-directLedgers" : singleData?.ledger_id === "Direct Ledgers" ? "directLedgers"
                          : ""
                      }
                    >
                      {singleData?.ledger_name}
                    </p>
                  </Link>
                ):<span  style={{
                  textDecoration:
                    singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers"
                      ? ""
                      : "",
                  cursor: "pointer",
                  color:
                    singleData?.ledger_id === "Indirect Ledgers" ? "#744bd1" : singleData?.ledger_id === "Direct Ledgers"
                      ? "#2080f6"
                      : "#2080f6",
                  padding:
                    singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers"
                      ? "4px 12px"
                      : "",
                }}
                className={
                  singleData?.ledger_id === "Indirect Ledgers" ? "in-directLedgers" : singleData?.ledger_id === "Direct Ledgers" ? "directLedgers"
                    : ""
                }
              >
                {singleData?.ledger_name}</span>}
              </td>
            );
            // </Link>}
          }
          if (thead?.value === "closing_amount") {
            return (
              <td className="light-count">
                {(singleData?.ledger_id === "Indirect Ledgers" || singleData?.ledger_id === "Direct Ledgers") ? "" : <>
                  {singleData?.total_amount
                    ? currencySignAndNegativeValueAdjust(currencySign,singleData?.total_amount?singleData?.total_amount?.toFixed(2)?.toString():"")
                    : 0}
                </>
                }
              </td>
            );
          }
        })}
      </tr>
    );
  }
};

export default CostOfGoodsStatementTableData;
